module.exports = __webpack_public_path__ + "static/media/wizard-face.2a49683a.svg";